export type EmpruntNonResidentWidgetViewState = "idle" | "submitting" | "success" | "error";

export const EMPRUNT_NON_RESIDENT_FORM_STEPS = [
  "intro",
  "profil",
  "finances",
  "contact",
  "result",
] as const;
export type EmpruntNonResidentFormStep = (typeof EMPRUNT_NON_RESIDENT_FORM_STEPS)[number];

export interface EmpruntNonResidentResultModel {
  score: number;
  conseil: string;
  pointsForts: string[];
  pointsFaibles: string[];
}

export interface EmpruntNonResidentFormModel {
  email: string;
  firstName: string;
  source: string;
  consent: boolean;
  paysResidence: string;
  statutProfessionnel: string;
  revenuMensuel: string;
  chargesMensuelles: string;
  apportDisponible: string;
  garantie: "Oui" | "Non";
  revenuCapital: string;
  dettesAssociees: string;
  expertComptable: boolean;
  courtier: boolean;
  chasseurImmobilier: boolean;
  honeypot: string;
}

export function getInitialEmpruntNonResidentFormStep(): EmpruntNonResidentFormStep {
  return EMPRUNT_NON_RESIDENT_FORM_STEPS[0];
}

export function getNextEmpruntNonResidentFormStep(
  currentStep: EmpruntNonResidentFormStep,
): EmpruntNonResidentFormStep {
  switch (currentStep) {
    case "intro":
      return "profil";
    case "profil":
      return "finances";
    case "finances":
      return "contact";
    case "contact":
      return "result";
    case "result":
      return "result";
    default:
      return currentStep;
  }
}

export function getPreviousEmpruntNonResidentFormStep(
  currentStep: EmpruntNonResidentFormStep,
): EmpruntNonResidentFormStep {
  switch (currentStep) {
    case "profil":
      return "intro";
    case "finances":
      return "profil";
    case "contact":
      return "finances";
    case "result":
      return "contact";
    default:
      return currentStep;
  }
}

export function getEmpruntNonResidentFormProgress(
  currentStep: EmpruntNonResidentFormStep,
): { current: number; total: number } {
  switch (currentStep) {
    case "intro":
      return { current: 0, total: 4 };
    case "profil":
      return { current: 1, total: 4 };
    case "finances":
      return { current: 2, total: 4 };
    case "contact":
      return { current: 3, total: 4 };
    case "result":
      return { current: 4, total: 4 };
    default:
      return { current: 0, total: 4 };
  }
}
